module.exports = __webpack_public_path__ + "static/img/legend_xg_english_dark.267dfb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/legend_xg_english_dark.png
// module id = zRyM
// module chunks = 94